/**
 *
 * @returns {number} Current unix timestamp in seconds
 */
export const getTimestamp = () => Math.floor(Date.now() / 1000)

export const isPastTimestamp = (timestamp: number) => timestamp < getTimestamp()
